import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (ids: string[]) => {
  if (!ids?.length) return []

  const { data, error } = await supabase
    .from('services')
    .select(`*`)
    .in('id', ids)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetServiceByidS(ids: string | string[]) {
  const serviceIds = Array.isArray(ids) ? ids : [ids]

  return useQuery({
    queryKey: ['useGetServiceByid', serviceIds],
    queryFn: () => getServices(serviceIds),
    staleTime: 0,
    enabled: !!serviceIds.length,
  })
}